/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useHistory } from "react-router-dom";
import { Grid, Icon } from "@material-ui/core";
import { FC, Fragment } from "react";
import { useFetchTemplateMetadataFromIdCallback } from "src/store/templateMetadata/hooks/useActions";
import { OverviewTableState } from "src/utils/internalLinksParsing";
import {
  IconName,
  NotificationId,
  TemplateNotification,
} from "../../../../../../globalTypes";
import {
  innerContainerCss,
  labelWrapperCss,
  notificationMessageCss,
  NotificationRow,
  notificationContainerCss,
  NotificationTitle,
  FabContainer,
} from "./styles";
import { setPrimaryAsColor } from "../../../../../../assets/styles/styles";
import { DeleteButton } from "../../../../../atoms/inputs/EwaButtons";

export type ExtendedTemplateMessage = TemplateNotification & {
  templateName: string;
  icon: IconName;
  link: {
    pathname: string;
    search: string;
    state: OverviewTableState;
  };
};

export type Props = {
  messages: ExtendedTemplateMessage[];
  dismissNotification: (id: NotificationId) => void;
  onCardClick: () => void;
};

const TemplateCardList: FC<Props> = ({
  messages,
  dismissNotification,
  onCardClick,
}) => {
  const fetchTemplateMetadata = useFetchTemplateMetadataFromIdCallback();
  const { push } = useHistory();
  const renderCard = (message: ExtendedTemplateMessage) => {
    const {
      notificationId,
      notificationIsTask,
      templateName,
      icon,
      link,
      label: notificationMessage,
      recordPrimaryKey,
      detailTemplateId,
    } = message;

    const onNotificationClick = async () => {
      await fetchTemplateMetadata(detailTemplateId, recordPrimaryKey);
      onCardClick();
      push(link);
      if (!notificationIsTask) {
        dismissNotification(notificationId);
      }
    };

    return (
      <NotificationRow key={notificationId} data-cy="notification-row">
        <div css={notificationContainerCss}>
          <Grid
            onClick={onNotificationClick}
            css={innerContainerCss}
            data-cy="notification-link"
          >
            <div css={labelWrapperCss}>
              <NotificationTitle>
                {icon && (
                  <Icon css={setPrimaryAsColor} data-cy="template-icon">
                    {icon}
                  </Icon>
                )}
                <span data-cy="template-name">{templateName}</span>
              </NotificationTitle>
              <p css={notificationMessageCss} data-cy="notification-title">
                {notificationMessage}
              </p>
            </div>
          </Grid>
        </div>
        {!notificationIsTask && (
          <FabContainer>
            <DeleteButton onClick={() => dismissNotification(notificationId)} />
          </FabContainer>
        )}
      </NotificationRow>
    );
  };

  return <Fragment>{messages.map(renderCard)}</Fragment>;
};

export default TemplateCardList;
export type TemplateCardListProps = Props;
